import React, { useEffect, useState } from "react";
import { AlternativeImage } from "Explore/Config/ImageType";
import { checkImageUrl } from "Explore/Utils/CheckImageUrl";

const ImageCheck = ({ url, className, type, altImg, alt, style = {} }) => {
  const [image, setImage] = useState(AlternativeImage[`${type}`]);
  useEffect(() => {
    checkImageUrl(url, setImage, type, altImg);
  }, [url, altImg, type]);
  return (
    <img
      src={image}
      alt={alt}
      className={className}
      style={style}
      draggable={false}
    />
  );
};

export default ImageCheck;
